import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent18: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Map the sales process</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Map the sales process
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step you will develop short-term, medium-term, and long-term sales strategies for your product. Understanding the details of customer acquisition will make clear to you the drivers of costs so that you will know over time how to make the sales process shorter and more cost-effective.

Mapping the sales process is a thoughtful first pass at how you will enter the market, refine your sales strategy over time, and ultimately establish an inexpensive long-term strategy for customer acquisition. The sales process includes creating awareness, educating the customer, and handling and processing the sale. The sales process drives the COCA, one of the variables—along with the Lifetime Value of an Acquired Customer—that shows your business’s profitability.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Answer key questions
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  To develop this short-term, medium-term, and long-term sales strategy, you must understand which sales channels you will use and how your use of sales channels will change over time. Think of the following key questions:

How does your target customer become aware that they have a problem or an opportunity?
How will the target customer learn that there is a solution to this problem they have, or learn there is the opportunity they did not previously know about?
Once the target customer knows about your business, what is the education process that allows them to make a well-informed analysis about whether to purchase your product?
How do you make the sale?
How do you collect the money?
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_3">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_3"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_3"
                  >
                    Create the sales map
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_3"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_3"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Create a table with two columns (customer segment / sales strategy) and three rows (short term / medium term / long term). Populate it with information on the sales process collected in the previous step:

What are your short term sales strategies for which customer segment?
What are your medium term sales strategies for which customer segment?
What are your long term sales strategies for which customer segment?
Vet the final sales process map with experienced professionals in the industry
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent18 };
